export function passwordPolicy(pw) {
  // true if good password
  if (pw.length > 12) {
    return { allowed: true, hasLetter: true, hasNumber: true, hasLength: true };
  }

  if (pw.length < 8) {
    return {
      allowed: false,
      hasLetter: false,
      hasNumber: false,
      hasLength: false,
    };
  }

  const hasLetter = /\p{L}/u.test(pw);
  const hasNumber = /[0-9]/.test(pw);

  return {
    allowed: hasLetter && hasNumber,
    hasLetter,
    hasNumber,
    hasLength: true,
  };
}
